/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfidenceStatsConfidenceCategoriesInner
 */
export interface ConfidenceStatsConfidenceCategoriesInner {
    /**
     * 
     * @type {string}
     * @memberof ConfidenceStatsConfidenceCategoriesInner
     */
    confidenceCategory: string;
    /**
     * 
     * @type {number}
     * @memberof ConfidenceStatsConfidenceCategoriesInner
     */
    count: number;
}

/**
 * Check if a given object implements the ConfidenceStatsConfidenceCategoriesInner interface.
 */
export function instanceOfConfidenceStatsConfidenceCategoriesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "confidenceCategory" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ConfidenceStatsConfidenceCategoriesInnerFromJSON(json: any): ConfidenceStatsConfidenceCategoriesInner {
    return ConfidenceStatsConfidenceCategoriesInnerFromJSONTyped(json, false);
}

export function ConfidenceStatsConfidenceCategoriesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfidenceStatsConfidenceCategoriesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'confidenceCategory': json['confidence_category'],
        'count': json['count'],
    };
}

export function ConfidenceStatsConfidenceCategoriesInnerToJSON(value?: ConfidenceStatsConfidenceCategoriesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'confidence_category': value.confidenceCategory,
        'count': value.count,
    };
}

